import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import sv from './locales/sv.json';

const STORAGE_KEY = 'kanplan-locale';

function pickInitialLanguage() {
	try {
		const raw = (typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY)) || '';
		const v = String(raw || '').trim().toLowerCase();
		if (v === 'en' || v === 'sv') return v;
	} catch {
		// ignore
	}
	try {
		const nav = (typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage)) || '';
		const lang = String(nav || '').toLowerCase();
		if (lang.startsWith('en')) return 'en';
		if (lang.startsWith('sv')) return 'sv';
	} catch {
		// ignore
	}
	return 'sv';
}

// Non-destructive: init i18n globally, but do not require any component to use it yet.
// Missing keys fall back to Swedish.
try {
	i18n
		.use(initReactI18next)
		.init({
			resources: {
				en: { translation: en },
				sv: { translation: sv },
			},
			lng: pickInitialLanguage(),
			fallbackLng: 'sv',
			supportedLngs: ['sv', 'en'],
			interpolation: { escapeValue: false },
		});
} catch {
	// If i18n init fails for any reason, keep the app running.
}

export function setAppLanguage(lang) {
	const next = String(lang || '').toLowerCase();
	if (next !== 'sv' && next !== 'en') return;
	try {
		if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, next);
	} catch {
		// ignore
	}
	try {
		i18n.changeLanguage(next);
	} catch {
		// ignore
	}
}

export default i18n;
